import { ViewModel, View, ObservableArray } from "binder"
import { MultiSelectorBaseViewModel } from "src/common/reusableComponents/multiSelectorBase/multiSelectorBase-viewModel";
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { DistrictSelectorViewModel } from "src/EnterpriseAdministration/districtManipulation/districtSelector";
import { ServerConnection } from "src/server/serverConnection";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { WarehouseManipulationView } from "./warehouseManipulation-view"

export class WarehouseManipulationViewModel extends WindowViewModel {
    public getTitle(): string {
        return 'مدیریت انبارها ‌';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.warehouses = ObservableArray.create<warehouse>();
        this.loader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 15);
        this.refresh();
    }
    GetDefaultView(): View<ViewModel> {
        return new WarehouseManipulationView();
    }
    public getTypeId(): string {
        return "VM-6DD90861-4B68-4BB9-8338-DADFCFDE891C"
    }
    public set warehouses(v: ObservableArray<warehouse>) { this._warehouses = v; } public get warehouses(): ObservableArray<warehouse> { return this._warehouses; } private _warehouses: ObservableArray<warehouse>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader; } private _loader: ServerSideDataLoader;

    refresh() {
        this.loader.refresh();
    }
    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetAllWarehouse', {
                NotCondition: true,
                FilteringInformation: filteringInformation
            });
            let rowNumber = 1;
            this.warehouses.update(...result.Warehouse.map(q => {

                let r = new warehouse(this);
                r.id = q.Id;
                r.districtId = q.DistrictId;
                r.districtName = q.DistrictName;
                r.name = q.Name;
                r.canDeliver = q.CanDeliver;
                r.canSale = q.CanSale;
                r.canSend = q.CanSend;
                r.mainWarehouseId = q.MainWarehouseId;
                r.mainWarehouseName = q.MainWarehouseName;
                r.rowNumber = rowNumber++;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }

    async requestWarehouseCreation() {
        let editor = new warehouseEditor(this, new InsertServerUpdater());
        let resultCode = await this.showPopup(editor);
        if (resultCode == 'done') {
            this.loader.refresh();
        }
    }

    async warehouseUpdater(warehouse: warehouse) {
        let editor = new warehouseEditor(this, new UpdateServerUpdater());
        warehouse.cloneTo(editor);
        let resultCode = await this.showPopup(editor);
        if (resultCode == 'done') {
            this.loader.refresh();
        }
    }
}

export class warehouse extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: WarehouseManipulationViewModel) {
        super(parent);
        this._typedParent = parent;

    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set canDeliver(v: boolean) { this._canDeliver = v; } public get canDeliver(): boolean { return this._canDeliver; } private _canDeliver: boolean;
    public set canSale(v: boolean) { this._canSale = v; } public get canSale(): boolean { return this._canSale; } private _canSale: boolean;
    public set canSend(v: boolean) { this._canSend = v; } public get canSend(): boolean { return this._canSend; } private _canSend: boolean;
    public set districtId(v: string) { this._districtId = v; } public get districtId(): string { return this._districtId; } private _districtId: string;
    public set districtName(v: string) { this._districtName = v; } public get districtName(): string { return this._districtName; } private _districtName: string;
    public set mainWarehouseId(v: string) { this._mainWarehouseId = v; } public get mainWarehouseId(): string { return this._mainWarehouseId; } private _mainWarehouseId: string;
    public set mainWarehouseName(v: string) { this._mainWarehouseName = v; } public get mainWarehouseName(): string { return this._mainWarehouseName; } private _mainWarehouseName: string;
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber; } private _rowNumber: number;

    private _typedParent: WarehouseManipulationViewModel;

    clone(parent: WarehouseManipulationViewModel): warehouse {
        let u = new warehouse(parent);
        this.cloneTo(u);
        return u;
    }

    cloneTo(warehouse: warehouse) {
        warehouse.id = this.id;
        warehouse.name = this.name;
        warehouse.canDeliver = this.canDeliver;
        warehouse.canSend = this.canSend;
        warehouse.canSale = this.canSale;
        warehouse.setDistrict(this.getDistrictId(), this.districtName);
        warehouse.setMainWarehouse(this.getMainWarehouseId(), this.mainWarehouseName);
    }

    async edit() {
        this._typedParent.warehouseUpdater(this);
    }

    setDistrict(id: string, name: string) {
        this.districtId = id;
        this.districtName = name;
    }

    getDistrictId() {
        return this.districtId;
    }

    setMainWarehouse(id: string, name: string) {
        this.mainWarehouseId = id;
        this.mainWarehouseName = name;
    }

    getMainWarehouseId() {
        return this.mainWarehouseId;
    }

}

interface IServerUpdater {
    execute(warehouse: warehouse): Promise<void>;
    getSuccessMessage(): string;
    isReadOnly(): boolean;
}

class InsertServerUpdater implements IServerUpdater {
    getSuccessMessage(): string {
        return 'انبار با موفقیت ثبت شد.';
    }
    isReadOnly(): boolean {
        return false;
    }
    async execute(warehouse: warehouse): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/CreateWarehouse', {
            Name: warehouse.name,
            CanDeliver: warehouse.canDeliver,
            CanSale: warehouse.canSale,
            CanSend: warehouse.canSend,
            District: warehouse.getDistrictId(),
            MainWarehouse: warehouse.getMainWarehouseId()

        });
        if (result.IsSuccessful == false) {
            throw "new Error";
        }
    }
}
class UpdateServerUpdater implements IServerUpdater {
    getSuccessMessage(): string {
        return 'انبار با موفقیت به روز رسانی شد.';

    }
    isReadOnly(): boolean {
        return true;
    }
    async execute(warehouse: warehouse): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/UpdateWarehouse', {
            Id: warehouse.id,
            Name: warehouse.name,
            MainWarehouse: warehouse.getMainWarehouseId(),
            CanDeliver: warehouse.canDeliver,
            CanSale: warehouse.canSale,
            CanSend: warehouse.canSend,
        });
        if (result.IsSuccessful == false) {
            throw "new Error";
        }
    }
}

export class warehouseEditor extends warehouse implements IPopup {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }

    constructor(parent: WarehouseManipulationViewModel, serverUpdater: IServerUpdater) {
        super(parent);
        this._serverUpdater = serverUpdater;
        this.districtSelector = new DistrictSelectorViewModel(this);
        this.mainWarehouseSelector = new WarehouseSelectorViewModel(this);
        this.isReadOnly = serverUpdater.isReadOnly();
    }
    closePopup(resultCode: string = null) {
    }

    private _serverUpdater: IServerUpdater;
    public set districtSelector(v: DistrictSelectorViewModel) { this._districtSelector = v; } public get districtSelector(): DistrictSelectorViewModel { return this._districtSelector; } private _districtSelector: DistrictSelectorViewModel;
    public set mainWarehouseSelector(v: WarehouseSelectorViewModel) { this._mainWarehouseSelector = v; } public get mainWarehouseSelector(): WarehouseSelectorViewModel { return this._mainWarehouseSelector; } private _mainWarehouseSelector: WarehouseSelectorViewModel;
    public set isReadOnly(v: boolean) { this._isReadOnly = v; } public get isReadOnly(): boolean { return this._isReadOnly; } private _isReadOnly: boolean;


    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    clearParent() {
        this.mainWarehouseSelector.selectedItem = null;
    }

    verify(): string[] {
        let result: string[] = [];
        if (stringIsNullOrEmpty(this.name)) {
            result.push('نام انبار مشخص نشده است.')
        }
        return result;
    }

    setDistrict(id: string, name: string) {
        this.districtSelector.selectById(id);
    }

    getDistrictId() {
        return this.districtSelector.selectedItem.id;
    }

    setMainWarehouse(id: string, name: string) {
        this.mainWarehouseSelector.selectById(id);
    }

    getMainWarehouseId() {
        return this.mainWarehouseSelector.selectedItem?.id;
    }

    async save() {
        try {
            let verificationResult = this.verify();
            if (verificationResult.length > 0) {
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage, 'عدم امکان ثبت انبار');
                return;
            }
            this.isLoading = true;
            await this._serverUpdater.execute(this);
            await this.messageBoxConfirmSuccess(this._serverUpdater.getSuccessMessage(), 'عملیات موفق');
            this.closePopup("done")
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات', 'خطا');
        } finally {
            this.isLoading = false;
        }
    }

    back() {
        this.closePopup();
    }
}

export class WarehouseSelectorViewModel extends SelectorBaseViewModel<WarehouseForSelector> {
    protected async loadData(): Promise<WarehouseForSelector[]> {
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetAllWarehouse', {
            NotCondition: true
        });
        return result.Warehouse.map(q => {
            let result = new WarehouseForSelector(this);
            result.id = q.Id;
            result.title = q.Name;
            return result;
        });
    }

}

export class CanSendWarehouseSelectorViewModel extends SelectorBaseViewModel<WarehouseForSelector> {
    protected async loadData(): Promise<WarehouseForSelector[]> {
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetAllWarehouse', {
            CanSend: true,
            CurrentDistrict: true
        });
        return result.Warehouse.map(q => {
            let result = new WarehouseForSelector(this);
            result.id = q.Id;
            result.title = q.Name;
            return result;
        });
    }

}

export class CurrentDistrictWarehousesSelectorViewModel extends SelectorBaseViewModel<WarehouseForSelector> {

    constructor(parentViewModel: ViewModel, notCondition: boolean = false, canSeeReport: boolean = false, canSeeManager: boolean = false, canSeeWorker: boolean = false, canSend: boolean = false, autoRefresh: boolean = true) {
        super(parentViewModel, true);
        this.canSeeReport = canSeeReport;
        this.canSeeManager = canSeeManager;
        this.canSeeWorker = canSeeWorker;
        this.canSend = canSend;
        this.notCondition = notCondition;
        if(autoRefresh == true){
            this.refresh();
        }
    }

    public set canSeeManager(v: boolean) { this._canSeeManager = v; } public get canSeeManager(): boolean { return this._canSeeManager; } private _canSeeManager: boolean;
    public set canSeeWorker(v: boolean) { this._canSeeWorker = v; } public get canSeeWorker(): boolean { return this._canSeeWorker; } private _canSeeWorker: boolean;
    public set canSeeReport(v: boolean) { this._canSeeReport = v; } public get canSeeReport(): boolean { return this._canSeeReport; } private _canSeeReport: boolean;
    public set canSend(v: boolean) { this._canSend = v; } public get canSend(): boolean { return this._canSend; } private _canSend: boolean;
    public set notCondition(v: boolean) { this._notCondition = v; } public get notCondition(): boolean { return this._notCondition; } private _notCondition: boolean;

    protected async loadData(): Promise<WarehouseForSelector[]> {
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetAllWarehouse', {
            CurrentDistrict: true,
            NotCondition: this.notCondition,
            SeeReports: this.canSeeReport,
            WarehouseManager: this.canSeeManager,
            CanSend: this.canSend,
            WarehouseWorker: this.canSeeWorker
        });
        return result.Warehouse.map(q => {
            let result = new WarehouseForSelector(this);
            result.id = q.Id;
            result.title = q.Name;
            return result;
        });
    }

}

export class WarehouseMultiSelectorViewModel extends MultiSelectorBaseViewModel<WarehouseForSelector> {

    constructor(parentViewModel: ViewModel, canSeeReport: boolean) {
        super(parentViewModel);
        this.canSeeReport = canSeeReport;
        this.refresh();
    }

    public set canSeeReport(v: boolean) { this._canSeeReport = v; } public get canSeeReport(): boolean { return this._canSeeReport; } private _canSeeReport: boolean;

    protected async loadData(): Promise<WarehouseForSelector[]> {

        let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetAllWarehouse', {
            CurrentDistrict: true,
            SeeReports: this.canSeeReport
        });
        return result.Warehouse.map(q => {
            let r = new WarehouseForSelector(this);
            r.id = q.Id;
            r.title = q.Name;
            return r;
        });
    }

    public selectAll() {
        this.selectById(this.items.map(q => q.id));
    }
}

export class WarehouseForSelector extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title; } private _title: string;
}